import { render, staticRenderFns } from "./ItemImageSlider.vue?vue&type=template&id=2727fc61&"
import script from "./ItemImageSlider.vue?vue&type=script&lang=js&"
export * from "./ItemImageSlider.vue?vue&type=script&lang=js&"
import style0 from "./ItemImageSlider.vue?vue&type=style&index=0&id=2727fc61&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports